import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import app from '@/store/modules/app';
import bc500 from '@/store/modules/app/bc500';
import admin from '@/store/modules/admin';
import socket from '@/store/modules/socket';
import history from '@/store/modules/history';
import device from '@/store/modules/device';
import map from '@/store/modules/map';
import mqtt from '@/store/modules/mqtt';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    admin,
    socket,
    history,
    device,
    map,
    bc500,
    mqtt
  },
  plugins: [
    createPersistedState({
      key: 'appSessionVuex',
      paths: [
        'app.menuCollapse',
        'app.deviceModel',
        'app.stateModel',
        'app.deviceMenuCollapse',
        'app.alarmVoice',
        'app.menuDefault',
        'app.theme'
      ],
      storage: window.sessionStorage
    }),
    createPersistedState({
      key: 'adminSessionVuex',
      paths: ['admin.userInfo'],
      storage: window.sessionStorage
    }),
    createPersistedState({
      key: 'mapLocalVuex',
      paths: ['map.mapZoom', 'map.mapThemeId']
    }),
    createPersistedState({
      key: 'socketSessionVuex',
      paths: ['socket.devicesSourseMap'],
      storage: window.sessionStorage
    }),
    createPersistedState({
      key: 'mqttSessionVuex',
      paths: ['mqtt.alarmData'],
      storage: window.sessionStorage
    }),
    createPersistedState({
      key: 'deviceSessionVuex',
      paths: ['device.monitorMenuActive', 'device.monitorMode'],
      storage: window.sessionStorage
    }),
    createPersistedState({
      key: 'deviceLocalVuex',
      paths: ['device.monitorConfig'],
      storage: window.localStorage
    })
  ]
});

export default store;
